import { Stack, Typography } from '@optimus-web/core';
import { Language } from '../LanguageSelectDialog';

interface GetLanguageCardOptions {
    languagesSorted: Language[];
}

export const getLanguageCardOptions = ({ languagesSorted }: GetLanguageCardOptions) =>
    languagesSorted.map((language) => ({
        label: (
            <Stack>
                <Typography textStyle="bodyMediumStrong" as="div">
                    {language.formattedCode}
                </Typography>
            </Stack>
        ),
        description: (
            <Typography textStyle="bodyMedium" variant="secondary" as="div">
                {language.localName}
            </Typography>
        ),
        name: language.code,
        value: language.code,
    }));
